import { useTranslation } from 'react-i18next'
import { Modal } from 'antd'

import AdvertisementForm from 'components/forms/AdvertisementForm'
import styles from './AdvertisementFormModal.module.scss'

const AdvertisementFormModal = ({ isVisible, onCancel, advertisement, submitCallback, loading }) => {
  const { t } = useTranslation()

  const handleCancel = () => onCancel()

  const handleSubmit = (data) => {
    submitCallback && submitCallback(data)
  }

  return (
    <Modal
      className={styles.modal}
      open={isVisible}
      onCancel={handleCancel}
      footer={null}
      centered={true}
      width={700}
    >
      <h3 className={styles.modal__title}>
        {advertisement
          ? t('advertisements.update', 'Update banner')
          : t('advertisements.new', 'New banner')}
      </h3>
      <div className={styles.modal__body}>
        <AdvertisementForm
          key={`${isVisible ? 'open' : 'closed'}-${advertisement?.id || 'new'}`}
          advertisement={advertisement}
          submitHandler={handleSubmit}
          loading={loading}
        />
      </div>
    </Modal>
  )
}

export default AdvertisementFormModal
